import { ReactNode } from 'react';

import BadgeStatus from '../../../../atoms/BadgeStatus';

export type BadgeColor = 'blue' | 'green' | 'red' | 'orange' | 'gray' | 'yellow' | 'purple' | 'indigo' | 'teal' | 'slate' | 'pending';

export interface BadgeLabel {
  text: string;
  color: BadgeColor;
}

export const classNames = (...items: Array<string | Record<string, boolean> | undefined | false>) =>
  items
    .flatMap((item) => (!item ? [] : typeof item === 'string' ? [item] : Object.keys(item).filter((key) => item[key])))
    .join(' ');

export const buttonClass = {
  secondary: 'rounded-md bg-gray-600 px-3 py-1.5 text-sm font-medium text-white hover:bg-gray-700 disabled:opacity-50 dark:bg-gray-500',
  cancel: 'rounded-md bg-gray-200 px-3 py-1.5 text-sm font-medium text-gray-800 hover:bg-gray-300 dark:bg-slate-700 dark:text-gray-100',
  destructive: 'rounded-md bg-red-600 px-3 py-1.5 text-sm font-medium text-white hover:bg-red-700 disabled:opacity-50 dark:bg-red-500',
};

export const inputClass =
  'rounded-md border border-gray-300 bg-white px-3 py-1.5 text-sm text-gray-900 focus:border-blue-500 focus:outline-none dark:border-gray-600 dark:bg-slate-700 dark:text-gray-100 dark:focus:text-blue-400';

export const Badge = ({ label }: { label: BadgeLabel }) => <BadgeStatus color={label.color} text={label.text} />;

export const EmptyState = ({ text }: { text: string }) => (
  <div className="py-10 text-center text-sm text-gray-500 dark:text-gray-400">{text}</div>
);

interface SectionProps {
  title: string;
  subtitle?: string;
  actions?: ReactNode;
  children: ReactNode;
}

export const Section = ({ title, subtitle, actions, children }: SectionProps) => (
  <section className="rounded-lg border border-gray-200 bg-white shadow-sm dark:border-gray-700 dark:bg-slate-800">
    <header className="flex flex-wrap items-center justify-between gap-2 border-b border-gray-200 px-4 py-3 dark:border-gray-700">
      <div>
        <h2 className="text-sm font-semibold text-gray-900 dark:text-gray-100">{title}</h2>
        {subtitle && <p className="text-xs text-gray-500 dark:text-gray-400">{subtitle}</p>}
      </div>
      {actions && <div className="flex items-center gap-2">{actions}</div>}
    </header>
    <div className="p-4">{children}</div>
  </section>
);

export const LoadError = ({ message, onRetry }: { message: string; onRetry: () => void }) => (
  <div className="flex items-center justify-between gap-3 rounded-md bg-red-50 px-3 py-2 text-sm text-red-700 dark:bg-red-900/30 dark:text-red-300">
    <span>{message}</span>
    <button type="button" className={buttonClass.cancel} onClick={onRetry}>
      Tentar de novo
    </button>
  </div>
);
